import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

interface ButtonProps {
  children: React.ReactNode;
  to: string;
}

export interface WebLinkProps extends ButtonProps {
  isNoramlText?: boolean;
  className?: string;
}

export const PrimaryLink: React.FC<ButtonProps> = ({ children, to }) => {
  return (
    <Link
      to={to}
      type="button"
      className="bg-sky-600 hover:bg-gradient-to-r hover:from-sky-700 hover:to-sky-600 drop-shadow hover:drop-shadow-xl px-4 py-1 rounded-lg font-bold text-white text-center"
    >
      {children}
    </Link>
  );
};

export const SecondaryLink: React.FC<ButtonProps> = ({ children, to }) => {
  return (
    <Link
      to={to}
      type="button"
      className="bg-white hover:bg-gray-50 shadow-sm px-2 py-1 rounded ring-1 ring-gray-300 ring-inset min-w-[80px] font-semibold text-gray-900 text-sm text-center"
    >
      {children}
    </Link>
  );
};

export const WebLink: React.FC<WebLinkProps> = ({
  children,
  to,
  isNoramlText,
  className: classNameProp,
}) => {
  const baseClass = isNoramlText ? '' : 'text-blue-600 font-semibold ';
  return (
    <Link
      to={to}
      type="button"
      className={classNameProp ? `${baseClass} ${classNameProp}`.trim() : baseClass}
    >
      {children}
    </Link>
  );
};

export const NavigateToLastPage: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      className="bg-white hover:bg-gray-50 shadow-sm px-2 py-1 rounded ring-1 ring-gray-300 ring-inset min-w-[80px] font-semibold text-gray-900 text-sm text-center"
    >
      {children}
    </button>
  );
};
